import {
  DEFAULT_CURRENCY_CODE,
  inject,
  LOCALE_ID,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { formatPriceBandOptions, PriceBand } from '@catalogue';
import { CurrencyCode, LocaleId } from '@i18n';
import { priceBands } from '../../constants/multi-plan-appliance-details-form-fields.constant';

@Pipe({ name: 'priceBand', standalone: true })
export class PriceBandPipe implements PipeTransform {
  private readonly currencyCode = inject<CurrencyCode>(DEFAULT_CURRENCY_CODE);
  private readonly localeId = inject<LocaleId>(LOCALE_ID);

  readonly formattedPriceBands: PriceBand[] = formatPriceBandOptions(
    priceBands as PriceBand[],
    this.currencyCode,
    this.localeId,
  );

  transform(purchasePrice: string | null | undefined): string | undefined {
    if (!purchasePrice) {
      return undefined;
    }
    const price = Number(purchasePrice);

    return this.formattedPriceBands.find((b) => price <= b.value)?.label;
  }
}
